import { Box, Image, SimpleGrid, Text } from "@chakra-ui/react";
import Rotate from 'react-reveal/Rotate';
import React from "react";
const Skills = () => {
  return (
    <Box id="skills" data-aos="fade-right">
      <Box mt="20px" w="100%" >
        <Box w="max-content" align="center" className="heading-hover" margin={'auto'}  mb='30px'>
          <Text
            className="about-H"
            fontSize={["2xl", "2xl", "3xl", "4xl"]}
            as="b"
            fontWeight='extrabold'
          >
            Tech Stack
          </Text>
          <span classNamed='underline-about'><span className='underline-about1'>Hands On Skills</span></span>
        </Box>

       
       
              <SimpleGrid
                columns={{ base: 2, sm: 3, md: 3, lg: 4 }}
                padding='8px'
                className="tech"
                gap='40px'
              >
                <Box
                  
                  bg="black"
                  borderRadius="md"
                  w="100%"
                  h="140px"
                   className="skills-card"
                >
                  <Rotate>
                  <Image
                    className="skills-card-img"
                    boxSize="100px"
                    src="https://chiranjeev-thapliyal.vercel.app/svg/html-5.svg"
                    alt="HTML"
                  ></Image></Rotate>
                  <Text as="b" align="center" fontWeight="800" className="skills-card-name">
                    HTML
                  </Text>
                </Box>

                <Box
                   className="skills-card"
                  bg="black"
                  borderRadius="md"
                  w="100%"
                  h="140px"
                >
                  <Rotate>
                  <Image
                    className="skills-card-img"
                    boxSize="100px"
                    src="https://chiranjeev-thapliyal.vercel.app/svg/css3.svg"
                    alt="CSS"
                  ></Image></Rotate>
                  <Text as="b" align="center" fontWeight="800" className="skills-card-name">
                    CSS
                  </Text>
                </Box>
                {/* <Box
                   className="skills-card"
                  bg="black"
                  borderRadius="md"
                  w="100%"
                  h="140px"
                ><Rotate>
                  <Image
                    className="skills-card-img"
                    boxSize="100px"
                    src="https://chiranjeev-thapliyal.vercel.app/svg/javascript.svg"
                    alt="javascript"
                  ></Image></Rotate>
                  <Text as="b" align="center" fontWeight="800" className="skills-card-name">
                    JAVASCRIPT
                  </Text>
                </Box>
                <Box
                   className="skills-card"
                  bg="black"
                  borderRadius="md"
                  w="100%"
                  h="140px"
                ><Rotate>
                  <Image
                    className="skills-card-img"
                    boxSize="100px"
                    src="https://chiranjeev-thapliyal.vercel.app/svg/reactjs.svg"
                    alt="react"
                  ></Image></Rotate>
                  <Text align="center" className="skills-card-name" fontWeight="800" as="b">
                    REACTJS
                  </Text>
                </Box> */}
                {/* <Box
                   className="skills-card"
                  bg="black"
                  borderRadius="md"
                  w="100%"
                  h="140px"
                >
                  {" "}<Rotate>
                  <Image
                    className="skills-card-img"
                    boxSize="100px"
                    src="https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg"
                    alt="react"
                  ></Image></Rotate>
                  <Text as="b" align="center" className="skills-card-name" fontWeight="800">
                    JAVA
                  </Text>
                </Box> */}
               
                <Box
                  bg="black"
                  borderRadius="md"
                  w="100%"
                  h="140px"
                   className="skills-card"
                ><Rotate>
                  <Image
                    className="skills-card-img"
                    boxSize="100px"
                    src="https://camo.githubusercontent.com/9f6fbaa3154800eef23c4dc7ed718f911deb50e0d5f58f9226d7dc278d901973/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f61746c61737369616e5f6a6972612f61746c61737369616e5f6a6972612d69636f6e2e737667"
                    alt="Selenium"
                  ></Image></Rotate>
                  <Text as="b" align="center" fontWeight="800" className="skills-card-name">
                    JIRA 
                  </Text>
                </Box>

                <Box
                  bg="black"
                  borderRadius="md"
                  w="100%"
                  h="140px"
                   className="skills-card"
                ><Rotate>
                  <Image
                    className="skills-card-img"
                    boxSize="100px"
                    src="https://raw.githubusercontent.com/detain/svg-logos/780f25886640cef088af994181646db2f6b1a3f8/svg/selenium-logo.svg"
                    alt="Selenium"
                  ></Image></Rotate>
                  <Text as="b" align="center" fontWeight="800" className="skills-card-name">
                    SELENIUM (JAVA)
                  </Text>
                </Box>

                <Box
                   className="skills-card"
                  bg="black"
                  borderRadius="md"
                  w="100%"
                  h="140px"
                ><Rotate>
                  <Image
                    className="skills-card-img"
                    mt="10px"
                    boxSize="80px"
                    src="https://blog.knoldus.com/wp-content/uploads/2022/04/cypress.png"
                    alt="CYPRESS"
                ></Image></Rotate>
                  <Text
                    align="center"
                    mt="9px"
                    fontWeight="800"
                    className="skills-card-name"
                    as="b"
                  >
                    CYPRESS (JAVASCRIPT)
                  </Text>
                </Box>


                <Box
                   className="skills-card"
                  bg="black"
                  borderRadius="md"
                  w="100%"
                  h="140px"
                ><Rotate>
                  <Image
                    className="skills-card-img"
                    mt="10px"
                    boxSize="80px"
                    src="https://wedevx.cdn.prismic.io/wedevx/9453029c-c498-4c6a-a9cb-fc399c334195_rest-api-icon+1.svg"
                    alt="CYPRESS"
                ></Image></Rotate>
                  <Text
                    align="center"
                    mt="9px"
                    fontWeight="800"
                    className="skills-card-name"
                    as="b"
                  >
                    API
                  </Text>
                </Box>

                <Box
                   className="skills-card"
                  bg="black"
                  borderRadius="md"
                  w="100%"
                  h="140px"
                ><Rotate>
                  <Image
                    className="skills-card-img"
                    mt="10px"
                    boxSize="80px"
                    src="https://cdn.icon-icons.com/icons2/2107/PNG/512/file_type_cucumber_icon_130657.png"
                    alt="CYPRESS"
                ></Image></Rotate>
                  <Text
                    align="center"
                    mt="9px"
                    fontWeight="800"
                    className="skills-card-name"
                    as="b"
                  >
                    CUCUMBER
                  </Text>
                </Box>

                <Box
                   className="skills-card"
                  bg="black"
                  borderRadius="md"
                  w="100%"
                  h="140px"
                >
                <Rotate>
                  <Image
                    className="skills-card-img"
                    mt="10px"
                    boxSize="80px"
                    src="https://camo.githubusercontent.com/4253eb6921d60a216772940978dea3a0cf2113f2f29b5545720d3b5b6960e467/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6d6f6368616a732f6d6f6368616a732d69636f6e2e737667"
                    alt="MOCHA"
                  ></Image></Rotate>
                  <Text
                    align="center"
                    fontWeight="800"
                    className="skills-card-name"
                    mt="8px"
                    as="b"
                  >
                    MOCHA
                  </Text>
                </Box>
                <Box
                   className="skills-card"
                  bg="black"
                  borderRadius="md"
                  w="100%"
                  h="140px"
                ><Rotate>
                  <Image
                    className="skills-card-img"
                    boxSize="100px"
                    src="https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667"
                    alt="POSTMAN"
                  ></Image></Rotate>
                  <Text align="center" as="b" className="skills-card-name" fontWeight="800">
                    POSTMAN
                  </Text>
                </Box>

                <Box
                   className="skills-card"
                  bg="black"
                  borderRadius="md"
                  w="100%"
                  h="140px"
                ><Rotate>
                  <Image
                    className="skills-card-img"
                    boxSize="100px"
                    src="https://techstack.boltcode.io/wp-content/uploads/2022/12/8k044akj7cl7kfdh-JmeterPlugins_140px@2x.png"
                    alt="react"
                  ></Image></Rotate>
                  <Text align="center" fontWeight="800" className="skills-card-name" as="b">
                    Apache-Jmeter
                  </Text>
                </Box>
               
                <Box
                   className="skills-card"
                  bg="black"
                  borderRadius="md"
                  w="100%"
                  h="140px"
                ><Rotate>
                  <Image
                    className="skills-card-img"
                    boxSize="100px"
                    src="https://camo.githubusercontent.com/265574c40f0816ed0fd67127cfbc382866182a7ec468c614906103c15700e707/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6a656e6b696e732f6a656e6b696e732d69636f6e2e737667"
                    alt="react"
                  ></Image></Rotate>
                  <Text align="center" fontWeight="800" className="skills-card-name" as="b">
                    JENKINS
                  </Text>
                </Box>

                <Box
                   className="skills-card"
                  bg="black"
                  borderRadius="md"
                  w="100%"
                  h="140px"
                ><Rotate>
                  <Image
                    className="skills-card-img"
                    boxSize="100px"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAflBMVEX///8AAACPj4/V1dX8/Pzz8/Pn5+fu7u7e3t739/c1NTXr6+v29vbx8fGlpaWwsLCYmJhRUVEfHx+CgoIlJSV6enrNzc07Ozu8vLxERER0dHRJSUlhYWHGxsZYWFgaGhpqamouLi6dnZ0LCwuQkJB/f3+tra0UFBQjIyNlZWWz/V0sAAALM0lEQVR4nO1da3eqOhDVgqhYBcUH9vgA7ev8/z94L6VWwITsCQmTrnX250KzJZn3TAaDf/gHFKNxMJl43tbzJpNgPOJejjkEx2iRHHbn67CO63l3SBbRMeBeoD6egzTehEM1wk2cBs/cyyVi5r0ezgC5O86HV2/GvWwUx2Tf3JIYrvvkyL14JUbRQYvcHYfIYSEUXJYd6ZVYXpwUP9P0ZIReiVM65SbUgLfRO3pyXDceN6k7ptGHYXolPiI3PuQ4pukFCs7xmJveIEis0SuR8EqdWWaZX4GMzxIY2/5+NyQ8e3Ua98SvQMwgc95XPRIcDlfvPfPzEKfBLMI+9eNzXwewjqQ3FytdsxAcDtdpL/zmXb2HLjjM7RNMGfkVsP0Z/Q0zweFw49skOOlfhD4inNgjeOEm942LJX5TThFTx8HKTg123Lwq2FnwOLbcpBrYmia44Gb0gIVZgvxK4hFvJgn+5WYjxF9zBM2EQc1jaYjfaM/NRIq9kfj42CUt0cTOQHxj3q8vT8VnZ2dj5DbB/yl23Kgjl7doiV0nir6rUrSKZRcj9TcQ7KQ03FT0j9BW/TwRNR0kegQj7nUTEOkQ9LhXTYJGuHjMvWYiyMaN764xKsaeqjNeuFdMxguN4G+SMjeQpE2gfN3ZTnGCFNdPtYFMiU6pDmEUzMdBECX9WK1ZvJ2NR/NAlZLd4wSfFK/Kf0717JIboiFDdq8dmqv+9gkleFS9qWZCTBJ71SbhoiYhlXURYOHfs3LFDfX6HNlRLYdmTFSZ9zpjOVRl5DB/fGZrvuzk6VFwjJS//QYhqLbWhK+Zm7XTX4UKXF0ciFhv6gSaJElpsLzmTRJ9eVc+GaoJAhk0afAnMBMaz6QJwon6YWXmTa3rh6uWx8Up1PUpiRfpcetNZqPRaDbxtsd0EScnYcVDa1WJenVKvQ/ELdoNwOoeuOaHS9qesZ2kl0NerU1t/wZAla4ipqFUhUNl0icoYx9hFnloLHPuRVn58Q+KL4BUmrUrRSRPr1Sr6W4TBVRnxg+izU5ZaIFUgrQKG8il4CxqBURNq5MxhYqdrFZ7KPCMLHAtXyGW6OVk6EMrlEoK6Adq+4Xsw4fc0qvMPFU5TSV2vVJqIofW+Cp+GNsBiF1kDz5YFil+Giy3EHgW/cEHk33ik/iJPcx7DkFvey16GA6vuS9Lh2L/B/bTObvnRugi/zw+i1ikJTg7rvBkymNVGJ4r1MrzGAIeqc6ajyojdXdoJuuMgBBGaB4mQmWeUE71BEKXQFNhUBoM+LoCp4RVNvQ2KR3aT9eDCKRGgbpEJIWQTkz8oCDGHbXqTHWYuwauhsAZaZWrqoeBK8NfxLCmEmlxTj6VT6ueqMTm/ZzyIJ+gIeam70lALL5zg8S77AmYl/6Ne6iW0u8qMGl7BSWRF/88Relm4h5ZAaQdfvATjqCIqL7bcR9B6fy4CX2CpcAapPlGji/3JhQJusKFaRyE/qSbvsCt7oyR2B14Rv3bDSIcQ4u9jQQQlFt5EHGTjc/krgM3wMs8Ga5EjXfEaQI/iWUNEVyu7oIgLQEr8K+E8AgWNIY7/joA1onrIlqDGwn8835uwAuYCxMM3tTcFmkVf9BFF6ID/uK2esR1APfNFyfrDf1jN5RhCVglFsEaVLmcXZr2p67h+8YJz1c5o+5LwN/Fx4OscAFuL4DNlClulXKGZx4Be3wzXFm44DjdAUfdtviP4ZIoJQjTFChKLbFyY0rjDXCU/h3Wne6Y3SVycN0XWOG7xhB1L95gxcJbCvUItF3nBNuwLtndBfB1ozFkU1M2TAH12/fwfv6t3zAc5PBv4RbQvZcP0LkXv1XSrAZop+Rv1RYfA3QON2vRpQA5uO4r0oXyBc46IRHgCCG8Sz/cibQVGMPrhiXNb/UtVoMc/dNf6h/msNR1JmlRAnbcd3jmnz+/XQXq1v5vi8F5Gc6y0kfAkajTAB5KanCGnwHAJc1/8ZRx6FIYw4fFxwuhrtglhYgnnxLCbGCX1AVewrcg1MK5kyCllA1FhDqFjJtWBXjByZFSJ8ZNqwJ80QGl/N2dg0iopJ0OpvhFTe4kgfFjePXxcIBLgQy8yLRYM2E4Indt6Q2EOrXCEoPz+O5sU0KJaZHHJxSHu7JNCZXQRaMdpYzdDWlKWXERmYAjHkPDY9C1QajXL6NLcH3RkLdD9gZsMEKJMhdBGZEYK/57H6DcI1LO0iH1oTCzK0C5S7Ls6CXdXMHvYMARmgJl+AzuAP8C90kkWJn31ZLmO3IHpEiNTzcFTrsCiDf2TWpC+zHCaF19vKlSimqrWCikp1j3KWmPViQ/cWgwX3yfeGHRfbIccWrwlesoTojXKt/nW1Bnd695VMaYetdGJcJLO79M8W+8MeQb1QIZ8rWwYf8B8IB8c2bViKZpmQJ53xENjz5euyYuqNt0CE8lNgSNqzPrdWo6M9h7bFvXujqzPimIMhblB8u+dqqnNWu6IQ31Zjn34xATooEVZI23EGd/3PBp/zTqXl77YHnpDlZf2rXhjrqj+x+nHb9qvkkwOt0cUg0Z/41HOSiOlO/eJ2N/dly0V2yEdvppOl3fLpihIzrPn/cfYJG3vvDJtDXu6cmXG0QunsiuOVckrq8w7ZYXYyR977XrXQRCRSZKQtV+ipkqTRW+RN3j/t57lnekJyv+ERqn9ROGSO4/cTrWG4/pz9InQ7eeSLaTUJzUbR/UwM+zZHGETR5/crwkB7LvIIesdUIcI6jbLfMc/z94utH0DW9S/SXWPmHNbsH9UErEihhhUkDeGyILK9aSamiKmXbDlNFbzVvEnSzoVrvLHAt4rWmBDnKIogVtv630+9QauSFnjWrm6BrYArSOBJRap1UFgwzVpjeCGbsRVOGZS6MhVZEKuFp0+8bUfYsfiv8jD2dUj6/SX9bpsKFMjWuBcsyx1CAMK9JGOXVYJ5FKSn1KoU4cyTfLG/RXJXTukiYMa24BYBjLXYiqpdBelqRX9W5C1kCRI+l5qJVEtVohejM0DBg2WA+hPABe03Ft69GLT2lGw6oARbg0613/hVo2ql4glTLWUgzY1pfGf+qGipdL/uxTzz98lr0PBd6NLd2nDUvFF3/tV91Jyl1DFwQzQ7oBm7J4FDeMoFXSIUZMGtf9CJISlhkt2eOfbuPTnzDc/1meNu+4Wy9Et0uIBWtrgbSvSJzf9s3cW9LpcsEdcQ0yuWa1ELpTMIO8fWTKyWaRQheVr3H8JdYbdJepJjow1MrzSUInFnNN+gwPWv9vmovfZi/zq80w16x+kVTofOq4RhB0Ga60a18kAnVtq+pLl2GHXSVzdC3N39Nk2CkbJNMZmZWyLz2GHUsJpGHMC3bJNwlaDDvvJ6kR/mk87avF0EDzQIujG74J7zOe6FLXYGikO0JVEbZMLoso3XrbY3EXdZbrjzqlMzR0Bxw5paBb8UZmaEymU0NEfX1DgwYkMafQE0Oj3ZATUlFYLwxXhu3jOSVKpNuRQWG4N++oEkIMPTC00s2K54bsM7R0UyhcTG6b4Ye1jusxmB3S3UIgw6XNVghsDXYZWh4O7yG5aN1oFcIwtD4TwAeWYZHhUx93ZnvKK8qtMVz3NdRBVb5LK/i6Q8Wwx95Or12o2mG47HcqR5r3zDDv/fYJv8X3zzTf2cJw0YeEaWIqPY6Z5hulDN+4JhpOJCnNTPN9EoYvnCMAAuGidMdkCisjn7inUz0LsnC6VpvAe4mdmLj53rTkdMVeM1gSujP3dls7kGdtuVerHnhxa3LxKLobAfqa+V7Is4wsZA26Ioi/wlX7LpIv+CrHOsdct7crEXhe17XNPI9beP6Da/gPfNWsZr34KLUAAAAASUVORK5CYII="
                    alt="react"
                  ></Image></Rotate>
                  <Text align="center" fontWeight="800" className="skills-card-name" as="b">
                    GITHUB
                  </Text>
                </Box>
              </SimpleGrid>
          
           

      </Box>
    </Box>
  );
};

export default Skills;
